import React from "react";
import TableSkeleton from "./TableSkeleton";
import styles from "./Table.module.css";

export default function Table({
  columns = [],
  rows = [],
  rowKey = (row, index) => row?.id || index,
  loading = false,
  skeletonRows = 6,
  emptyText = "No records found.",
  className = "",
}) {
  return (
    <div className={`${styles.wrap} ${className}`.trim()}>
      <table className={styles.table}>
        <thead>
          <tr>
            {columns.map((column) => (
              <th key={column.key} className={column.headerClassName || ""}>
                {typeof column.headerRender === "function"
                  ? column.headerRender()
                  : column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <TableSkeleton columns={columns} rows={skeletonRows} />
          ) : rows.length > 0 ? (
            rows.map((row, index) => (
              <tr key={rowKey(row, index)}>
                {columns.map((column, cellIndex) => (
                  <td key={column.key} data-label={column.label} className={column.cellClassName || ""}>
                    {typeof column.render === "function"
                      ? column.render(row, index)
                      : row?.[column.key] ?? ""}
                  </td>
                ))}
              </tr>
            ))
          ) : (
            <tr>
              <td className={styles.empty} colSpan={columns.length}>
                {emptyText}
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
